import { Fragment, useRef, useState } from 'react';

import CloseIcon from '@/components/Icon/CloseIcon';
import UploadIcon from '@/components/Icon/UploadIcon';

import * as S from './style';

interface InputFileProps {
	file: File | null;
	setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

export default function InputFile({ file, setFile }: InputFileProps) {
	const [isDragging, setIsDragging] = useState<boolean>(false);
	const fileInputRef = useRef<HTMLInputElement | null>(null);

	const formatBytesToKB = (bytes: number) => {
		if (bytes === 0) return '0 KB'; // 파일 크기가 0일 때 처리
		return `${Math.round(bytes / 1024)} KB`;
	};

	const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(true);
	};
	const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(false);
	};
	const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		if (!isDragging) {
			setIsDragging(true);
		}
	};
	const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(false);

		if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
			handleFiles(e.dataTransfer.files[0]);
			e.dataTransfer.clearData();
		}
	};
	const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		console.log(`e.target : `, e.target);
		if (e.target.files && e.target.files.length > 0) {
			handleFiles(e.target.files[0]);
			e.target.value = ''; // 동일 파일 재선택을 위한 input 초기화
		}
	};

	const handleFiles = (singleFile: File) => {
		setFile(singleFile);
	};
	const triggerFileInput = () => {
		fileInputRef.current?.click();
	};

	const removeFile = () => {
		setFile(null);
	};

	return (
		<S.Container>
			<S.DropZone
				isDragging={isDragging}
				onDragEnter={handleDragEnter}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onDrop={handleDrop}
				onClick={triggerFileInput}
			>
				<S.HiddenInput type="file" ref={fileInputRef} onChange={handleFileInputChange} />

				<S.DropText>드래그 혹은 파일 업로드</S.DropText>
				<UploadIcon />
			</S.DropZone>

			{file !== null && (
				<S.FileList>
					<S.FileListUl>
						<S.FileItem>
							<S.FileContent>
								<div className="title">{file?.name ?? ''}</div>
								<div className="sub_title">{formatBytesToKB(file?.size ?? 0)}</div>
							</S.FileContent>
							<div
								onClick={(e: any) => {
									e.stopPropagation();
									removeFile();
								}}
							>
								<CloseIcon iconColor="#ADB5BD" width="20" height="20" />
							</div>
						</S.FileItem>
					</S.FileListUl>
				</S.FileList>
			)}
		</S.Container>
	);
}
